var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShopInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#9B9B9B",
  fillRule: "evenodd",
  d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14m.566-9.243c-.416 0-1.05-.287-1.05-.976 0-.7.674-.981 1.05-.981.443 0 1.047.323 1.047.98a1 1 0 0 1-1.047.977m.817 6.016-.081.034c-.32.135-.93.393-1.493.393-.57 0-1.35-.262-1.35-1.104 0-.51.19-1.135.37-1.73.165-.54.321-1.056.321-1.44 0-.869-1.096-.438-1.24-.381l-.01.004.117-.48.088-.036c.324-.135.938-.391 1.487-.391.49 0 1.324.176 1.324 1.104 0 .49-.192 1.137-.373 1.748-.162.548-.316 1.067-.316 1.42v.024c-.001.207-.003.51.618.51.25 0 .594-.126.656-.154z",
  clipRule: "evenodd"
})));
export { SvgShopInfo as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvc2hvcC1pbmZvLmMxMDg5YzQyLnN2ZyI7";